import { useState } from 'react';
import { useSelector } from 'react-redux';

import FilterCustomEmails from './FilterCustomEmails/FilterCustomEmails';
import { Button } from 'antd';
import { t } from '../../i18n/i18n';

export const HeaderCustomEmails = ({
  handleSubmit,
  onClickNewCustomEmail,
  headers,
  setHeaders,
  idCustomTable,
}) => {
  const [showMoreFilters, setShowMoreFilters] = useState(false);

  return (
    <div className="container-fluid bg-white rounded-top px-4 pt-4 pb-3">
      <div className="d-flex">
        <div className="w-100 d-flex justify-content-between align-items-center">
          <div className="flex-grow-1">
            <FilterCustomEmails handleSubmit={handleSubmit} showMoreFilters={showMoreFilters} />
          </div>
          <Button
            className="font-weight-700 bg-maya-blue text-white abm-redirect-button rounded ml-3"
            onClick={onClickNewCustomEmail}
            type="primary"
            size="large"
          >
            {t('ABM_CREATE_EMAIL')}
          </Button>
        </div>
      </div>
    </div>
  );
};
